import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define types for the state and payload
interface User {
  id: string;
  email: string;
  mobile_verified_at: string;
  // Add other fields for the user as needed
}

interface AuthState {
  user: User | null;
  is2FARequired: boolean | false,
  is2FAValidated: boolean | false,
  token: string | null;
}

interface SetCredentialsPayload {
  user: User;
  accessToken: string;
}

interface Set2FACredentialsPayload {
  is2FARequired: boolean,
  is2FAValidated: boolean,
}

// Define the initial state with the correct types
const initialState: AuthState = {
  user: null,
  is2FARequired: false,
  is2FAValidated: false,
  token: null,
};

const authAdapter = createEntityAdapter<User>();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Type the action payload
    /* setUserFromLocalStorage: (state, action: PayloadAction<User[]>) => {
      authAdapter.setAll(state, action.payload);
    }, */
    setCredentials: (state, action: PayloadAction<SetCredentialsPayload>) => {
      const { user, accessToken } = action.payload;
      state.user = user;
      state.token = accessToken;
    },
    set2FACredentials: (state, action: PayloadAction<Set2FACredentialsPayload>) => {
      const { is2FARequired, is2FAValidated } = action.payload;
      state.is2FARequired = is2FARequired;
      state.is2FAValidated = is2FAValidated;
    },
    logOut: (state) => {
      state.user = null;
      state.is2FARequired = false;
      state.is2FAValidated = false;
      state.token = null;
    },
  },
  
});

export const { setCredentials, set2FACredentials, logOut } = authSlice.actions;
export default authSlice.reducer;

// Selectors with proper typing
export const selectCurrentUser = (state: { auth: AuthState }) => state.auth.user;
export const selectIs2FARequired = (state: { auth: AuthState }) => state.auth.is2FARequired;
export const selectIs2FAValidated = (state: { auth: AuthState }) => state.auth.is2FAValidated;
export const selectCurrentToken = (state: { auth: AuthState }) => state.auth.token;
